import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Trans } from 'gatsby-plugin-react-i18next';

interface InputProps {
  label?: React.ReactNode;
  className?: string;
  id?: string;
  name: string;
  fontsize: string;
  min?: number;
  max?: number;
  value: number;
  isLight?: boolean;
  onChange(value: number): void;
}

const NumberInput: React.FC<InputProps> = ({ className, label, id, name, fontsize, min, max, onChange, value, isLight = false }) => {
  const [internalValue, setValue] = useState(value || 1);

  useEffect(() => {
    setValue(value);
  }, [value]);

  const handleChange = (event: any) => {
    setValue(parseInt(event.target.value, 10));
    onChange(parseInt(event.target.value, 10));
  };

  const handlePlusChange = () => {
    const newValue = max && internalValue + 1 > max ? internalValue : internalValue + 1;

    onChange(newValue);
  };

  const handleMinusChange = () => {
    const newValue = (min && internalValue - 1 < min) || internalValue - 1 === 0 ? internalValue : internalValue - 1;

    onChange(newValue);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', py: '0.2rem', }}>
      <Typography variant="body2" component="h2" sx={{ pr: '4px' }}>
        <Trans>Quantity:</Trans>
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 0,
          m: 0,
          border: 'solid 1px #00000022',
          fontSize: `${fontsize}`,
          width: 'fit-content',
        }}
      >
        <IconButton
          aria-label="increase"
          sx={{
            p: 0,
            m: 0,
            '&:hover': {
              bgcolor: '#ffffff',
            },
          }}
          onClick={handleMinusChange}
        >
          <RemoveIcon sx={{ fontSize: `${fontsize}`, zIndex: '-1' }} />
        </IconButton>
        <InputBase
          type="number"
          color='secondary'
          inputProps={{
            style: { textAlign: 'center' },
          }}
          value={internalValue}
          onChange={handleChange}
          sx={{
            p: 0,
            m: 0,
            width: '3rem',
            height: '1.1rem',
            borderLeft: 'solid 1px #00000022',
            borderRight: 'solid 1px #00000022',
            // zIndex: '-1',
          }}
        />
        <IconButton
          aria-label="decrease"
          sx={{
            p: 0,
            m: 0,
            '&:hover': {
              bgcolor: '#ffffff',
            },
          }}
          onClick={handlePlusChange}
        >
          <AddIcon sx={{ fontSize: `${fontsize}`, zIndex: '-1' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default NumberInput;
